module.exports = __webpack_public_path__ + "static/media/4ODA4.0c7b84e2.jpg";